(ns iris.posts.views
  (:require
   [re-frame.core :as re-frame]
   [cljs.core.async :refer [go go-loop <! >! timeout chan]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.posts.events :as posts-events]
   [iris.posts.subs :as posts-subs]
   [iris.subs :as subs]
   [goog.html.utils :refer [stripHtmlTags]]
   [goog.date.relative]
   [goog.functions :as gfn]
   [iris.utils :as utils]
   [iris.firebase :as fb]
   [iris.data.api :as data]
   [iris.hench :as hench]
   [iris.common :as common]
  ;;  [iris.routes :as routes]
   [cemerick.url :as cemerick.url]
   [reagent.core :as reagent :refer [atom]]
   [iris.posts.views.post :as post]
   [iris.posts.views.filter-top-bar :refer [filter-top-bar]]
   [iris.posts.views.posts-logs-switch :refer [posts-logs-switch]]
   [iris.posts.views.limit-btns :refer [limit-btns]]
  ;;  [iris.posts.views.text-resizer :refer [text-resizer]]
   [iris.posts.views.company-panel :refer [company-panel]]
   [iris.posts.views.posts-table :refer [posts-table posts-table-2]]
   [iris.posts.views.user-btn :refer [user-btn]]
   [iris.posts.views.moderator-bar :as moderator-bar]
   [iris.posts.views.post-screening-options :refer [post-screening-options]]
   [iris.posts.views.thread-alert-btn :refer [thread-alert-btn]]
   [iris.posts.common :refer [route-prefix reorder-post-id]]
   [clojure.string :as string]
   [iris.posts.views.social-bar :refer [social-bar]]
   [iris.posts.views.reply-alert :refer [reply-alert]]
   [iris.posts.views.tags :refer [tags]]
   [iris.routes :as routes]
  ;;  ["@fingerprintjs/fingerprintjs" :as Fingerprint2]
  ;;  [herb.core :refer [<class <id]]
   [iris.styles.posts :as $posts]
  ;;  [iris.styles.general :as $general]
   [iris.fingerprint]
  ;;  [iris.styles.general]

   [clerk.core :as clerk]

   [iris.globals :as globals]

   [iris.search.views :refer [search-inputs-embed]]
   [iris.events :as events]

   [iris.posts.views.forms :as forms] 
   ))




;; (.log js/console Fingerprint2)

;; (js/requestIdleCallback
;;  (fn []
;;    (.get
;;     Fingerprint2
;;     (fn [components]
;;       (.log js/console
;;             (.x64hash128
;;              Fingerprint2
;;              (.join (.map components (fn [pair] (.-value pair))))
;;              31))))))





;; import Fingerprint2 from 'fingerprintjs2'

;; (println "TEST::" (string/replace (first (string/split "/acme.TLO" #"\.")) #"\/|\.|\$|\[|\]|\#" ""))


;; (println "TEST:" (first (string/split "/acme.TLO" #"\.")))

;; (let [test (first (string/split "/_homepage.TLO" #"\."))]
;;   (println (string/replace test #"/|\.|\$|\[|\]|\#" ""))
;;   )

;; (social-bar "" "" "" "" "/acme.TLO")


;; (defonce route-prefix "/new")


;; TODO: keep this for loading via scroll
;; (defn createPost []
;;   (println "creating post"))

;; (.addEventListener
;;  js/window
;;  "scroll"
;;  (gfn/debounce
;;   (fn []
;;     (println "scrolling...")
;;     (let [scrollHeight (.. js/document -documentElement -scrollHeight)
;;           scrollTop (.. js/document -documentElement -scrollTop)
;;           clientHeight (.. js/document -documentElement -clientHeight)]
;;       (when (> (+ scrollTop clientHeight) (- scrollHeight 5))
;;         (js/setTimeout createPost 1000)))) 500))




;; (go-loop []
;;   (<! (timeout 60000))
;;   (println "TIMEOUT 60000")
;;   (re-frame/dispatch [::posts-events/set-timer (.now js/Date)])
;;   ;; TODO: this definitely has to do with data jumping back/forth, consider cancelling timeout on Post.List
;;   ;; (re-frame/dispatch [::posts-events/set-post-fb-data])
;;   (recur))


;; (defn set-raid-len [e raid-len]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::events/set-raid-len raid-len]))

;; (defn raid-len-btns []
;;   (let [raid-len @(re-frame/subscribe [::subs/raid-len])
;;         raid-len-max 5
;;         raid-len-min 2
;;         inc-btn-css-class (if (>= raid-len raid-len-max) "btn-success disabled" "btn-success")
;;         dec-btn-css-class (if (<= raid-len raid-len-min) "btn-danger disabled" "btn-danger")]
;;     [:div.btn-group.btn-group-sm
;;      {:role "group"}
;;      [:a.btn {:title "list view"
;;               :class inc-btn-css-class
;;               :on-click (fn [e] (set-raid-len e (+ raid-len 1)))} "+"]
;;      [:span.btn.disabled {:title "table view"
;;                           :class "btn-default"}
;;       raid-len]
;;      [:a.btn {:title "table 2 view"
;;               :class dec-btn-css-class
;;               :on-click (fn [e] (set-raid-len e (- raid-len 1)))}
;;       "-"]]))




(defn display-top-bar [qp]
  [:div#display-top-bar
   {:style {:text-align "center" :margin-top "10px"}}
   [:div#display-switches.container-fluid
    [:span {:class
            ;; (<class $posts/filter-display-labels)
            $posts/$filter-display-labels
            }"\n\t\tDisplay:\n\t\t\n\n"]
    [:div.btn-group.btn-group-sm
     {:role "group"
      :style {:margin "5px"}}
     [:a.btn
      {:title "Display processed/censored text"
       :href (str "?" (cemerick.url/map->query (dissoc qp :raw)))
       :class (if (not= (:raw qp) "yes") "btn-primary" "btn-default")}
      "processed"]
     [:a.btn
      {:title "Display text as submitted"
       :href
      ;;  "?ws=TLO&limit=50&page=1&raw=yes"
       (str "?" (cemerick.url/map->query (conj qp {:raw "yes"})))
       :class (if (= (:raw qp) "yes") "btn-primary" "btn-default")}
      "raw"]]

    [:div.btn-group.btn-group-sm
     {:role "group"
      :style {:margin "5px"}}
     [:a.btn
      {:href (str "?" (cemerick.url/map->query (dissoc qp :excerpt)))
       :class (if (not= (:excerpt qp) "yes") "btn-primary" "btn-default")
       :title "Display full text"}
      "full text"]
     [:a.btn
      {:href
      ;;  "?ws=TLO&limit=50&page=1&excerpt=yes"
       (str "?" (cemerick.url/map->query (conj qp {:excerpt "yes"})))
       :class (if (= (:excerpt qp) "yes") "btn-primary" "btn-default")
       :title "Display excerpt"}
      "excerpt"]]

    [:div.btn-group.btn-group-sm
     {:role "group"
      :style {:margin "5px"}}
     [:a.btn {:title "list view"
              :href (str "?" (cemerick.url/map->query (dissoc qp :layout)))
              :class (if (nil? (:layout qp)) "btn-primary" "btn-default")} "list"]
     [:a.btn {:title "Display table view"
              :href
      ;;  "?ws=TLO&limit=50&page=1&layout=table"
              (str "?" (cemerick.url/map->query (conj qp {:layout "table"})))
              :class (if (= (:layout qp) "table") "btn-primary" "btn-default")}
      "table"]
     [:a.btn {:title "Display table 2 view"
              :href
      ;;  "?ws=TLO&limit=50&page=1&layout=table2"
              (str "?" (cemerick.url/map->query (conj qp {:layout "table2"})))
              :class (if (= (:layout qp) "table2") "btn-primary" "btn-default")}
      "table2"]]



[:div.btn-group.btn-group-sm
 {:role "group"
  :style {:margin "5px"}}
    [:button.btn {:class "btn-default btn-success"
                  :on-click (fn [e] (re-frame/dispatch [::events/redo]))
                  :title "Refresh posts"}
     [:span {:class "glyphicon glyphicon-refresh"}]
     [:span {:class
            ;;  (<class $general/refresh-btn-label)
             "global-refresh-btn-label"
             } " Refresh"]]
]

    ;; [:div.btn-group.btn-group-sm
    ;;  {:role "group"}
    ;;  [:a.btn {:title "list view"

    ;;           :class "btn-default btn-success"} "+"]
    ;;  [:span.btn.disabled {:title "table view"
    ;;                       :class "btn-default"}
    ;;   "3"]
    ;;  [:a.btn {:title "table 2 view"

    ;;           :class "btn-default btn-danger"}
    ;;   "-"]]
    ;; [common/raid-len-btns]
    ]])





;; (defn status-icon [status]
;;   (cond (= status "P") [:i.glyphicon.glyphicon-ok-circle]
;;         (= status "S") [:i.glyphicon.glyphicon-upload]
;;         (= status "Q") [:i.glyphicon.glyphicon-minus-sign]
;;         (= status "R") [:i.glyphicon.glyphicon-remove-circle]
;;         (= status "T") [:i.glyphicon.glyphicon-remove-sign]))

;; (defn status-color [status]
;;   (cond (= status "P") "text-success"
;;         (= status "S") "text-primary"
;;         (= status "Q") "text-warning"
;;         (= status "R") "text-danger"
;;         (= status "T") "text-secondary"))

;; (defn author-eid-raid [d k]
;;   (if-let [raid (get-in d [:author :raid k])]
;;     raid
;;     (if-let [eid (get-in d [:author :eid k])]
;;       (hench/temp-prefix eid)
;;       "")))


;; (defn post-filters [d qp]
;;   [:div.filters.text-right
;;    [:div.btn-group.btn-group-xs.ip-buttons
;;     {:role "group"}
;;     [:a.btn.btn-default [:i.glyphicon.glyphicon-filter]]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :cc]) "cc")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:cc (get-in d [:author :cc])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:cc (get-in d [:author :cc])}))))}
;;      ":cc"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :g_eid]) "g_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:geo (get-in d [:author :eid :g_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:geo (get-in d [:author :eid :g_eid])}))))}
;;      "!geo"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :ip]) "ip")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:ip (get-in d [:author :ip])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:ip (get-in d [:author :ip])}))))}
;;      "^ip"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :c_eid]) "c_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:cookie (get-in d [:author :eid :c_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:cookie (get-in d [:author :eid :c_eid])}))))}
;;      "*ck"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :f_eid]) "f_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:bfp (get-in d [:author :eid :f_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:bfp (get-in d [:author :eid :f_eid])}))))}
;;      "&bfp"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :d_eid]) "d_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:dfp (get-in d [:author :eid :d_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:dfp (get-in d [:author :eid :d_eid])}))))}
;;      "~dfp"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :a_eid]) "a_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:ua (get-in d [:author :eid :a_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:ua (get-in d [:author :eid :a_eid])}))))}
;;      "%ua"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :m_eid]) "m_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:mime (get-in d [:author :eid :m_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:mime (get-in d [:author :eid :m_eid])}))))}
;;      "m:mime"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:author :eid :l_eid]) "l_eid")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:lang (get-in d [:author :eid :l_eid])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:lang (get-in d [:author :eid :l_eid])}))))}
;;      "l:lang"]
;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:thread]) "thread")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:thread (subs (get-in d [:thread]) 1)})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:thread (subs (get-in d [:thread]) 1)}))))}
;;      "+thread"]


;;     (when (true? (get-in d [:author :staff]))
;;       [:a.btn.btn-default
;;        {:href
;;         (str route-prefix "/posts?" (cemerick.url/map->query
;;                                      (-> qp
;;                                          (dissoc :bm)
;;                                          (conj {:user (get-in d [:author :uid])}))))}
;;        "=usr"])


;;     [:a.btn.btn-default
;;      {;; :key (str (:id d) (get-in d [:forum]) "forum")
;;       :href
;;       (str route-prefix "/posts?" (cemerick.url/map->query
;;                                   ;;  (conj qp {:board (get-in d [:forum])})
;;                                    (-> qp
;;                                        (dissoc :bm)
;;                                        (conj {:board (get-in d [:forum])}))))}
;;      "/board"]]])



;; (defn post-screen [scopes-input disable-in actions notes]
;;   (re-frame/dispatch [::posts-events/screen-create  {:disable_in disable-in
;;                                                      :actions actions
;;                                                      :scopes_input scopes-input
;;                                                      :priority 0
;;                                                      :kind "catchall"
;;                                                      :notes notes
;;                                                      :enabled true
;;                                                      :target_level 0}]))


;; (defn prep-screen-notes [id forum type action]
;;   (str "Created for post " id " in forum " forum " by pressing the "
;;        (cond
;;          (and (= type "ip") (= action "ban")) "\"Ban IP\" button #bannedip"
;;          (and (= type "ip") (= action "quarantine")) "\"Quarantine IP\" button #quarantinedip"
;;          (and (= type "eid") (= action "quarantine")) "\"Quarantine EID\" button #quarantinedeid"
;;          (and (= type "2of3") (= action "quarantine")) "\"Quarantine 2/3\" button #quarantined2of3")))


;; (defn create-screen
;;   ([e val id forum action type disable-in actions]
;;    (.preventDefault e)
;;    (let [scopes-input val
;;          notes (prep-screen-notes id forum type action)]
;;      (post-screen scopes-input disable-in actions notes)))
;;   ([e val1 val2 val3 id forum action type disable-in actions]
;;    (.preventDefault e)
;;    (let [scopes-input (str forum " AND min2(" val1 " OR " val2 " OR " val3 ")")
;;          notes (prep-screen-notes id forum type action)]
;;      (post-screen scopes-input disable-in actions notes))))

;; .text-danger
;; font-style: italic;
;; font-weight: 700;
;; color: #a94442

;; .text-warning
;; color: #8a6d3b
;; font-style: italic;
;; (defn screening-status [ss eid]
;;   (cond (> (:n_enabled ss) 0)
;;         [:span.text-danger
;;          [:strong
;;           [:em eid]]]
;;         (> (:n_disabled ss) 0)
;;         [:span.text-warning
;;          [:em eid]]
;;         :else
;;         eid))

;; (defn screening-status-class [ss]
;;   (cond (> (:n_enabled ss) 0)
;;         {:font-style "italic" :font-weight 700 :color "#a94442"}
;;         (> (:n_disabled ss) 0)
;;         {:color "#8a6d3b" :font-style "italic"}
;;         :else
;;         {}))

;; (defn cc-btn [d]
;;   (let [cc (get-in d [:author :cc])
;;         country (get-in d [:author :country])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status (str ":" cc)])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {:title country
;;       :href (str route-prefix "/cc/" cc)
;;       :style css}
;;      cc]))

;; (defn ip-btn [d raid]
;;   (let [ip (get-in d [:author :ip])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status (str "^" ip)])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {:title (str "IP address " ip)
;;       :href (str route-prefix "/ip/" ip)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :i_eid)}}]))

;; (defn g_eid-btn [d raid]
;;   (let [g_eid (get-in d [:author :eid :g_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status g_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {:title "US:sc:indian land:35.001610,-80.855810"
;;       :href
;;       (str route-prefix "/eid/" g_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :g_eid)}}]))

;; (defn c_eid-btn [d raid]
;;   (let [c_eid (get-in d [:author :eid :c_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status c_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {:title "Cookie EID"
;;       :href
;;       (str route-prefix "/eid/" c_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :c_eid)}}]))



;; (defn f_eid-btn [d raid]
;;   (let [f_eid (get-in d [:author :eid :f_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status f_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {:title "BFP EID"
;;       :href
;;       (str route-prefix "/eid/" f_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :f_eid)}}]))


;; (defn d_eid-btn [d raid]
;;   (let [d_eid (get-in d [:author :eid :d_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status d_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {:title "DFP EID"
;;       :href
;;       (str route-prefix "/eid/" d_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :d_eid)}}]))

;; (defn a_eid-btn [d raid]
;;   (let [a_eid (get-in d [:author :eid :a_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status a_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {;; TODO: title needs to be obtained somehow, perhaps an api call to Scope.GetEidMetadata on mouse over?
;;     ;; even better would be if it was included in screening status meta data, then every instance of it on the page would get it
;;     ;; :title "User agent Mozilla/5.0 (iPhone; CPU iPhone OS 15_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.3 Mobile/15E148 Safari/604.1"
;;       :href
;;       (str route-prefix "/eid/" a_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :a_eid)}}]))

;; (defn m_eid-btn [d raid]
;;   (let [m_eid (get-in d [:author :eid :m_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status m_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {;; :title "Accepts MIME type: '*/*'"
;;       :href (str route-prefix "/eid/" m_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :m_eid)}}]))


;; (defn l_eid-btn [d raid]
;;   (let [l_eid (get-in d [:author :eid :l_eid])
;;         ss (re-frame/subscribe [::posts-subs/batch-meta-screning-status l_eid])
;;         css (screening-status-class @ss)]
;;     [:a.btn.btn-default
;;      {;; :title "Accepts languages: 'en-US,en;q=0.9'"
;;       :href (str route-prefix "/eid/" l_eid)
;;       :style (merge {:min-width "35px"
;;                      :text-align
;;                      (if (some? raid) "center" "left")}
;;                     css)
;;       :dangerouslySetInnerHTML
;;       {:__html
;;        (hench/author-eid-raid d raid :l_eid)}}]))

;; (defn post-screening-options [d]
;;   (let [raid @(re-frame/subscribe [::posts-subs/fb-data :raid (:id d)])]
;;     [:div.btn-group.btn-group-xs.ip-buttons
;;      {:role "group"}
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "United States" :href (str route-prefix "/cc/" (get-in d [:author :cc]))}
;;     ;;   (str ":" (get-in d [:author :cc]))]
;;      [cc-btn d]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "US:sc:indian land:35.001610,-80.855810"
;;     ;;    :href
;;     ;;    (str route-prefix "/eid/" (get-in d [:author :eid :g_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :g_eid)
;;     ;;     (hench/author-eid-raid d raid :g_eid)}}]
;;      [g_eid-btn d raid]
;;      [:a.btn.btn-default
;;       {:target "ip2location"
;;        :title "Lookup IP geo location at ip2location.com"
;;        :href (str "http://www.ip2location.com/demo/" (get-in d [:author :ip]))}
;;       [:i.glyphicon.glyphicon-globe]]
;;      [:a.btn.btn-danger.btn-grey-click.btn-disabled-click
;;       {;;  :target "apollo"
;;        :title "Ban IP address for 7 days"
;;        :on-click (fn [e] (create-screen e
;;                                         (get-in d [:author :ip])
;;                                         (get-in d [:id])
;;                                         (get-in d [:forum])
;;                                         "ban"
;;                                         "ip"
;;                                         "7 d"
;;                                         [{:action "ban"}]))}
;;       [:i.glyphicon.glyphicon-ban-circle]]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title (str "IP address " (get-in d [:author :ip]))
;;     ;;    :href (str route-prefix "/ip/" (get-in d [:author :ip]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :i_eid)
;;     ;;     (hench/author-eid-raid d raid :i_eid)}}]
;;      [ip-btn d raid]
;;      [:a.btn.btn-danger.btn-grey-click.btn-disabled-click
;;       {;;  :target "apollo"
;;        :title "Quarantine IP for 6 months"
;;        :on-click (fn [e] (create-screen e
;;                                         (get-in d [:author :ip])
;;                                         (get-in d [:id])
;;                                         (get-in d [:forum])
;;                                         "quarantine"
;;                                         "ip"
;;                                         "6 m"
;;                                         [{:action "quarantine"
;;                                           :delay_min 60
;;                                           :delay_max 120}]))}
;;       [:i.glyphicon.glyphicon-tower]]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "Cookie EID"
;;     ;;    :href
;;     ;;    (str route-prefix "/eid/" (get-in d [:author :eid :c_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :c_eid)
;;     ;;     (hench/author-eid-raid d raid :c_eid)}}]
;;      [c_eid-btn d raid]
;;      [:a.btn.btn-danger.btn-grey-click.btn-disabled-click
;;       {;;  :target "apollo"
;;        :title "Quarantine cookie for 6 months"
;;        :on-click (fn [e] (create-screen e
;;                                         (get-in d [:author :eid :c_eid])
;;                                         (get-in d [:id])
;;                                         (get-in d [:forum])
;;                                         "quarantine"
;;                                         "eid"
;;                                         "6 m"
;;                                         [{:action "quarantine"
;;                                           :delay_min 60
;;                                           :delay_max 120}]))}
;;       [:i.glyphicon.glyphicon-tower]]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "BFP EID"
;;     ;;    :href
;;     ;;    (str route-prefix "/eid/" (get-in d [:author :eid :f_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :f_eid)
;;     ;;     (hench/author-eid-raid d raid :f_eid)}}]
;;      [f_eid-btn d raid]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "DFP EID"
;;     ;;    :href
;;     ;;    (str route-prefix "/eid/" (get-in d [:author :eid :d_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}}
;;     ;;   [:span.text-danger [:strong [:em
;;     ;;                                {:dangerouslySetInnerHTML
;;     ;;                                 {:__html
;;     ;;                                 ;;  (hench/author-eid-raid d :d_eid)
;;     ;;                                  (hench/author-eid-raid d raid :d_eid)}}]]]]
;;      [d_eid-btn d raid]
;;      [:a.btn.btn-danger.btn-grey-click.btn-disabled-click
;;       {;;  :target "apollo"
;;        :title (str "Quarantine 2 out of 3 (cookie, BFP, DFP) in forum " (get-in d [:forum]))
;;        :on-click (fn [e] (create-screen e
;;                                         (get-in d [:author :eid :c_eid])
;;                                         (get-in d [:author :eid :f_eid])
;;                                         (get-in d [:author :eid :d_eid])
;;                                         (get-in d [:id])
;;                                         (get-in d [:forum])
;;                                         "quarantine"
;;                                         "2of3"
;;                                         "6 m"
;;                                         [{:action "quarantine"
;;                                           :delay_min 60
;;                                           :delay_max 120}]))}
;;       [:i.glyphicon.glyphicon-tower]
;;       " ⅔\n\t\t\t"]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title
;;     ;;    "User agent Mozilla/5.0 (iPhone; CPU iPhone OS 15_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.3 Mobile/15E148 Safari/604.1"
;;     ;;    :href
;;     ;;    (str route-prefix "/eid/" (get-in d [:author :eid :a_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :a_eid)
;;     ;;     (hench/author-eid-raid d raid :a_eid)}}]
;;      [a_eid-btn d raid]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "Accepts MIME type: '*/*'"
;;     ;;    :href (str route-prefix "/eid/" (get-in d [:author :eid :m_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :m_eid)
;;     ;;     (hench/author-eid-raid d raid :m_eid)}}]
;;      [m_eid-btn d raid]
;;     ;;  [:a.btn.btn-default
;;     ;;   {:title "Accepts languages: 'en-US,en;q=0.9'"
;;     ;;    :href (str route-prefix "/eid/" (get-in d [:author :eid :l_eid]))
;;     ;;    :style {:min-width "35px"
;;     ;;            :text-align
;;     ;;           ;;  (if (get-in d [:author :raid]) "center" "left")
;;     ;;            (if (some? raid) "center" "left")}
;;     ;;    :dangerouslySetInnerHTML
;;     ;;    {:__html
;;     ;;     ;; (hench/author-eid-raid d :l_eid)
;;     ;;     (hench/author-eid-raid d raid :l_eid)}}]
;;      [l_eid-btn d raid]
;;      ]))



;; (defn on-post-remove [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-remove id]))

;; (defn on-post-approve [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-approve id]))

;; (defn on-post-hide [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-hide id]))

;; (defn on-post-unhide [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-unhide id]))

;; (defn on-enable-replying [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-enable-replying id]))

;; (defn on-disable-replying [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-disable-replying id]))

;; (defn on-qc-pass [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-qc-pass id]))


;; (defn on-publish [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-post-publish id]))




;; (defn moderator-bar-remove-btn [id]
;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
;;    {:title "Remove"
;;     :on-click (fn [e] (on-post-remove e id))}
;;    [:i.glyphicon.glyphicon-remove]])

;; (defn moderator-bar-approve-btn [id]
;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-success
;;    {:title "Approve"
;;     :on-click (fn [e] (on-post-approve e id))}
;;    [:i.glyphicon.glyphicon-ok]])

;; (defn moderator-bar-hide-btn [id]
;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
;;    {:title "Post not hidden. Click to hide"
;;     :on-click (fn [e] (on-post-hide e id))}
;;    [:i.glyphicon.glyphicon-eye-close]])

;; (defn moderator-bar-unhide-btn [id]
;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-success
;;    {:title "Post hidden. Click to unhide"
;;     :on-click (fn [e] (on-post-unhide e id))}
;;    [:i.glyphicon.glyphicon-eye-open]])

;; (defn moderator-bar-enable-replying-btn [id]
;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-success
;;    {:title "Unlock thread for posting"
;;     :on-click (fn [e] (on-enable-replying e id))}
;;    [:i.glyphicon.glyphicon-play]])

;; (defn moderator-bar-disable-replying-btn [id]
;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
;;    {:title "Lock thread for posting"
;;     :on-click (fn [e] (on-disable-replying e id))}
;;    [:i.glyphicon.glyphicon-pause]])

;; (defn moderator-bar-qc-pass-btn [id]
;;   [:a.btn.btn-default.qc-not-checked-btn
;;    {:title "QC not checked. Click to mark as QC pass"
;;     :on-click (fn [e] (on-qc-pass e id))}
;;    [:span.text-warning [:i.glyphicon.glyphicon-unchecked]]])

;; (defn moderator-bar-qc-checked [qc-by]
;;   [:span.btn.btn-default.disabled
;;    {:style {:pointer-events "auto"}
;;     :title (str "Approved by " qc-by)}
;;    [:span.text-success [:i.glyphicon.glyphicon-check]]])

;; (defn moderator-bar-publish-btn [id]
;;   [:a.btn.btn-default
;;    {:title "Process"
;;     :on-click (fn [e] (on-publish e id))}
;;    [:i.glyphicon.glyphicon-file]])


;; (defn moderator-bar-status-btn [id status]
;;   [:a.btn.btn-default
;;    {:title (str "Status: " status) ;; we actually need full status string, this is just first letter
;;     :style {:font-family "Arial" :font-weight "bold"}
;;     :href (str "https://athena.ipad.org/p/" id)}
;;    [:span {:class (status-color status)} (str status " ") [status-icon status]]])






;; (defn on-click-thread-refresh [e id]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::posts-events/http-thread-refresh-replies id]))





;; (defn post-votes [id]
;;   (let [votes @(re-frame/subscribe [::posts-subs/fb-data :votes (keyword id)])]
;;     [:span.vote-reactions-counter
;;      [:span {:class (<class $posts/counter-red globals/NVOTES_COUNTER_RED (:t votes))}
;;       [:span (:t votes)]
;;       " reactions"
;;       [:span " (+" (:u votes)]
;;       "/"
;;       [:span "-" (:d votes)]
;;       ")"]]))


;; (defn screen-notes [d]
;;   (when (:screen_notes d)
;;     [:pre {:title "Screen notes"} (:screen_notes d)]))


(defn personal-moderator-logs []
  (let [timer @(re-frame/subscribe [::posts-subs/timer])
        show-moderator-logs @(re-frame/subscribe [::subs/show-moderator-logs])
        logs @(re-frame/subscribe [::posts-subs/moderation-logs])]
    (when (true? show-moderator-logs)
      (let [logs-desc (sort-by
                      ;;  :datetime
                      :ms
                       #(compare %2 %1) logs)]
        [:div {:class
                ;; (<class $posts/moderator-logs)
               $posts/$moderator-logs
               }
         [:h3
          ;; {:class (<class $posts/moderator-logs-h3)}
          "Most recent post actions"]
         [:p
          ;; {:class (<class $posts/moderator-logs-p)}
          "Displaying the latest " (count logs) " log(s) of " (:limit-to-last globals/MODERATOR_LOG_SETTINGS) " max limit."]
         [:ul
          ;; {:class (<class $posts/moderator-logs-ul)}
          (cond (> (count logs) 0)
                (for [log logs-desc]
                  (let [relative2 (utils/dt2ago (.toISOString (new js/Date
                                                                   ;;  (:datetime log)
                                                                   (:ms log))) true)
                        log-href (if
                                  ;; (contains? log :id)
                                  (contains? log :ruid)
                                   (str "/t/" (reorder-post-id
                                               ;;  (:id log)
                                               (:ruid log))) "")]
                    [:li {:key (str (gensym "plog-")
                                    ;; (:datetime log)
                                    (:ms log))
                          ;; :class (<class $posts/moderator-logs-li)
                          }
                     ;;  (cond (contains? log :status)
                     ;;        [:a {:href log-href :class (<class $posts/moderator-logs-li-a)}
                     ;;         (:id log) " status changed to " [:strong {:class (moderator-bar/status-color (:status log))} (:status log)] " " relative2]
                     ;;        (contains? log :replying_disabled)
                     ;;        [:a {:href log-href :class (<class $posts/moderator-logs-li-a)}
                     ;;         (:id log) (if (true? (:replying_disabled log)) " replying disabled" " replying enabled") " " relative2]
                     ;;        (contains? log :hidden)
                     ;;        [:a {:href log-href :class (<class $posts/moderator-logs-li-a)}
                     ;;         (:id log) " hidden set to " (str (:hidden log)) " " relative2])

                     [:a {:href log-href
                          ;; :class (<class $posts/moderator-logs-li-a)
                          }
                      (:ruid log) " " [:strong (:action log)] " " relative2]]))
                :else
                [:li {:class
                      ;; (<class $posts/moderator-logs-li-empty-list)
                      ;; $posts/$moderator-logs-empty-list
                      "moderator-logs-empty-list"
                      } "Moderator log list is empty"])]]))))

;; (defn moderator-logs-ul-li [l]
;;   (let [timer @(re-frame/subscribe [::posts-subs/timer])
;;         relative2 (utils/dt2ago (.toISOString (new js/Date
;;                                                   ;;  (:datetime l)
;;                                                    (:ms l))))]
;;     ;; (cond (contains? l :status)
;;     ;;       [:li {:key (str "log" (:datetime l))} "Status set to " [:strong {:class (moderator-bar/status-color (:status l))} (:status l)] " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2]
;;     ;;       (contains? l :replying_disabled)
;;     ;;       [:li {:key (str "log" (:datetime l))} (if (true? (:replying_disabled l)) "Replying Disabled" "Replying Enabled") " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2]
;;     ;;       (contains? l :hidden)
;;     ;;       [:li {:key (str "log" (:datetime l))} "Hidden set to " (str (:hidden l)) " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2])
;;     [:li  (str (:action l)) " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2]
;;     ))


;; (defn moderator-logs [d logs]
;;   (println "modr logs::" logs)
;;   (when (> (count logs) 0)
;;     (let [logs-desc (sort-by :datetime #(compare %2 %1) logs)]
;;       (println "logs-desc::" logs-desc)

;;         [:<>
;;          [:pre {:title "Moderator Logs"}
;;           [:ul {:class (<class $posts/all-moderator-logs-ul)}
;;            (for [l logs-desc]
;;              [moderator-logs-ul-li l])

;;            ]]])))

;; (defn moderator-logs [d logs show]
;; (defn moderator-logs [index d logs]
;;   (reagent/with-let [show-logs (reagent/atom false)]
;;    (when (> (count logs) 0)
;;     (let [logs-desc (sort-by
;;                     ;;  :datetime
;;                      :ms
;;                      #(compare %2 %1) logs)
;;           ;; show (reagent/atom false)
;;           ]
;;       ;; (println "show:" @show)
;;       [:<>
;;        [:pre {:title "Moderator Logs"}
;;         [:ul {:class (<class $posts/all-moderator-logs-ul)}
;;          (for [l (take 2 logs-desc)]
;;            ^{:key (str (gensym "log-") (:ms l))} [moderator-logs-ul-li l])

;;         ;;  (when (true? @show)
;;         ;;    (for [l (nthrest logs-desc 2)]
;;         ;;      [moderator-logs-ul-li l]))
;;          (when (true?
;;                 ;; (:show-logs d)
;;                 (true? @show-logs)
;;                 )
;;            (for [l (nthrest logs-desc 2)]
;;              ^{:key (str (gensym "log-") (:ms l))} [moderator-logs-ul-li l]))

;;         ;;  (when (> (count logs) 2)
;;         ;;    [:li {:class (<class $posts/all-moderator-logs-more-btn)}
;;         ;;     [:a {:on-click (fn [e]
;;         ;;                      (.preventDefault e)
;;         ;;                      (reset! show (not @show)))}
;;         ;;      (if (true? @show) "less" "more")]])

;;          (when (> (count logs) 2)
;;            [:li {:class (<class $posts/all-moderator-logs-more-btn)}
;;             [:a {:on-click (fn [e]
;;                              (.preventDefault e)
;;                             ;;  (reset! show (not @show))
;;                             ;;  (re-frame/dispatch [::posts-events/set-posts-data-row-prop index :show-logs (not (:show-logs d))])
;;                              (reset! show-logs (not @show-logs))
;;                              )}
;;              (if (true?
;;                   ;; @show
;;                   ;; (:show-logs d)
;;                   (true? @show-logs)
;;                   ) "less" "more")]])

;;          ]]]))))


;; (defn moderator-logs [d logs]
;;   (println "modr logs::" logs)
;;   (when (> (count logs) 0)
;;     (let [logs-desc (sort-by :datetime #(compare %2 %1) logs)
;;           show (reagent/atom false)]
;;       (println "logs-desc::" logs-desc)
;;       (fn []
;;         [:<>
;;          [:pre {:title "Moderator Logs"}
;;           [:ul {:class (<class $posts/all-moderator-logs-ul)}
;;            (for [l (take 2 logs-desc)]
;;              [moderator-logs-ul-li l])
;;            (when (true? @show)
;;              (for [l (nthrest logs-desc 2)]
;;                [moderator-logs-ul-li l]))
;;            (when (> (count logs) 2)
;;              [:li {:class (<class $posts/all-moderator-logs-more-btn)}
;;               [:a {:on-click (fn [e]
;;                                (.preventDefault e)
;;                                (reset! show (not @show)))}
;;                (if (true? @show) "less" "more")]])]]]))))


;; (defn post-mod-logs-border-style [logs batch-datetime]
;;   (when (> (count logs) 0)
;;     (let [mod-logs-desc (sort-by
;;                         ;;  :datetime
;;                          :ms
;;                          #(compare %2 %1) logs)
;;           mod-logs-latest (first mod-logs-desc)]
;;     ;; (cond (= (:status mod-logs-latest) "R")
;;     ;;       {:border "2px solid #d9534f" :border-radius "5px"}
;;     ;;       (= (:status mod-logs-latest) "P")
;;     ;;       {:border "2px solid #5cb85c" :border-radius "5px"})
;;       ;; (println "TIMEDIFF::" (- (.now js/Date) (:datetime mod-logs-latest)))
;;       (cond (and (= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
;;                 ;;  (>= (:datetime mod-logs-latest) batch-datetime)
;;                  (>= (:ms mod-logs-latest) batch-datetime))
;;             {:border "2px solid rgb(102,157,246)" :border-radius "5px"}
;;             (and (not= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
;;                 ;;  (< (/ (- (.now js/Date) (:datetime mod-logs-latest)) 1000) 300)
;;                 ;;  (>= (:datetime mod-logs-latest) batch-datetime)
;;                  (>= (:ms mod-logs-latest) batch-datetime))
;;             {:border "2px solid orange" :border-radius "5px"}
;;             ;; (not= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
;;             ;; {:border "2px solid slategrey" :border-radius "5px"}
;;             ))))




;; moved to posts events
;; (defn post-logs-update [d logs]
;;   (when (> (count logs) 0)
;;     ;; reduce logs sorted in ascending order
;;     (let [logs-asc (sort-by :datetime logs)
;;           logs-last (last logs-asc)
;;           logs-flat (reduce (fn [res item]
;;                               (cond-> res
;;                                 (contains? item :status) (assoc :status (:status item))
;;                                 (contains? item :replying_disabled) (assoc :replying_disabled (:replying_disabled item))
;;                                 (contains? item :hidden) (assoc :hidden (:hidden item))))
;;                             {}
;;                             logs-asc)

;;           updates (cond-> {}
;;                     (and (contains? logs-flat :status) (or (not= (:status logs-flat) (:status d)) (and (= (:status logs-flat) (:status d)) (= (:qc d) false)))) (assoc :status (:status logs-flat))
;;                     (and (contains? logs-flat :replying_disabled) (not= (:replying_disabled logs-flat) (:replying_disabled d))) (assoc :replying_disabled (:replying_disabled logs-flat))
;;                     (and (contains? logs-flat :hidden) (not= (:hidden logs-flat) (:hidden d))) (assoc :hidden (:hidden logs-flat)))]
;;       (println "updates::" (:id d) updates
;;               ;;  (sort-by :datetime logs)
;;               ;;  logs-flat
;;                )
;;       ;; perhaps need to add qc_by, based on who did last log (or first??)
;;       (when-not (empty? updates)
;;         (re-frame/dispatch [::posts-events/update-post-props (:id d) (conj updates {:qc true :qc_by (:uid logs-last)})])
;;         )
;;       )))



;; (defn post-highlight-wrap [{:keys [highlight-a highlight-b highlight-c content]}]
;;   (let [outer (cond-> [:div.post-wrapper {}
;;                        [:div.post-inner-wrapper {}
;;                         [:div.post-content content]]]
;;                 highlight-c (assoc-in [1 1] :class "highlight-c")
;;                 highlight-b (assoc-in [1 0] :class "highlight-b")
;;                 highlight-a (assoc-in [0] :class "highlight-a"))]
;;     outer))

(defn post-highlight-wrap [{:keys [highlight-a highlight-b highlight-c content]}]
  (let [base [:div {:class "post-content"} content]
        flags [["highlight-a" highlight-a]
               ["highlight-b" highlight-b]
               ["highlight-c" highlight-c]]
        layers (->> flags
                    (filter (fn [[_ v]] v))  ; <- safe truthy check
                    (map first))]
    (reduce (fn [child class-name]
              [:div {:class class-name} child])
            base
            (reverse layers))))




(defn post-reply
  ([d index]
   (post-reply d index true))
  ([d index full-id]
   (let [qp @(re-frame/subscribe [::posts-subs/query-params])
         ap @(re-frame/subscribe [::subs/anchor-params])
         mobile @(re-frame/subscribe [::subs/mobile])
         roles @(re-frame/subscribe [::subs/roles])
         logs @(re-frame/subscribe [::posts-subs/all-moderation-log (:id d)])
         batch-datetime @(re-frame/subscribe [::posts-subs/batch-datetime])
         refs @(re-frame/subscribe [::posts-subs/posts-ref-preview-data (:id d)])

         post-mods (post/post-mod-logs-border-style logs batch-datetime)
         post-mod-by-me-highlight? (:post-mod-by-me post-mods)
         post-mod-by-others-highlight? (:post-mod-by-others post-mods)
         anchor-highlight? (and (some? ap) (= (:nick d) (str "@" ap)))]

     [:div.row.no-pad.post-wrap.reply-wrap
      {:key (:id d)
       :class
       (str (when (or (= (:status d) "R") (= (:status d) "T") (= (:status d) "Q") (= (:status d) "S")) "removed")
            (when mobile " mobile")
            ;; (when (and (some? ap) (= (:nick d) (str "@" ap))) " post-highlight")
            )
       ;;  :style (post/post-mod-logs-border-style logs batch-datetime)
       }
      [post-highlight-wrap
       {:highlight-a post-mod-by-me-highlight?
        :highlight-b post-mod-by-others-highlight?
        :highlight-c anchor-highlight?
        :content [:article.post.reply
                  {:id  (if (true? full-id)
                          (subs (:id d) 1)
                          (subs (:id d)  1 (string/index-of (:id d) (:thread d))))
                   :ruid (subs (:id d) 1)
                   :class (when (or (= (:status d) "R") (= (:status d) "Q")) "removed")
                   ;; TODO: needs to be full id on posts page, and hash id inside thread
                   ;; :id (subs (:id d)  1 (string/index-of (:id d) (:thread d)))
                   :itemScope true}
                  [moderator-bar/reply-btns d roles]
                  [post/post-timestamp d]
                  [post/post-body d qp]
                  [post/post-ref-preview (:id d) refs batch-datetime]
                  [post/post-footer index d qp roles logs]]}]])))



;; (defn post-replies [id]
;; (defn post-replies [d]

;;   (let [replies @(re-frame/subscribe [::posts-subs/fb-data :replies (keyword (:id d))])
;;         replies-n (:n replies)
;;         replies-t (:t replies)
;;         replies-msg (if (> replies-n 1)
;;                       (str replies-n " replies")
;;                       (if (> replies-n 0)
;;                         (str replies-n " reply")
;;                         "no replies"))]

;;     [:span.reply-counter
;;      [:span
;;       (cond (> replies-n 0)
;;             [:<>
;;              [:a
;;               {:href (str route-prefix (:thread_path d) "#replies")
;;                :class (<class $posts/counter-red globals/NREPLIES_COUNTER_RED replies-n)}
;;               [:strong
;;                [:span
;;                 replies-msg]]]

;;              [:span " (last "]
;;              (let [;;  date (new js/Date (:iso_published d))
;;               ;;  ms (.getTime date)
;;               ;;  relative (goog.date.relative/format ms)
;;                    timer @(re-frame/subscribe [::posts-subs/timer])
;;                    relative2 (utils/dt2ago (.toISOString (new js/Date (* replies-t 1000))))]
;;                [:time relative2])
;;              [:span ")"]]
;;             :else replies-msg)]]))








(defn post-op
  ([d index]
   (post-op d index true))
  ([d index full-id]
   (let [qp @(re-frame/subscribe [::posts-subs/query-params])
         ap @(re-frame/subscribe [::subs/anchor-params])
         mobile @(re-frame/subscribe [::subs/mobile])
         roles @(re-frame/subscribe [::subs/roles])
         logs @(re-frame/subscribe [::posts-subs/all-moderation-log (:id d)])
         batch-datetime @(re-frame/subscribe [::posts-subs/batch-datetime])
         refs @(re-frame/subscribe [::posts-subs/posts-ref-preview-data (:id d)])

         post-mods (post/post-mod-logs-border-style logs batch-datetime)
         post-mod-by-me-highlight? (:post-mod-by-me post-mods)
         post-mod-by-others-highlight? (:post-mod-by-others post-mods)
         anchor-highlight? (and (some? ap) (= (:nick d) (str "@" ap)))]

     [:div.row.no-pad.post-wrap.topic-wrap
      {:key (:id d)
       :class (str (when (or (= (:status d) "R") (= (:status d) "Q") (= (:status d) "S")) "removed")
                   (when mobile " mobile")
                   ;;  (when (and (some? ap) (= (:nick d) (str "@" ap))) " post-highlight")
                   )
       ;;  :style (post/post-mod-logs-border-style logs batch-datetime)
       }


      [post-highlight-wrap
       {:highlight-a post-mod-by-me-highlight?
        :highlight-b post-mod-by-others-highlight?
        :highlight-c anchor-highlight?
        :content [:article.post.topic
                  {:id (if (true? full-id)
                         (subs (:id d) 1)
                         (subs (:id d)  1 (string/index-of (:id d) (:thread d))))
                   :ruid (subs (:id d) 1)
                   :class (when (or (= (:status d) "R") (= (:status d) "Q")) "removed")
                   :itemScope true}
                  [moderator-bar/op-btns d roles]
                  [post/post-timestamp d]
                  [post/post-header d qp full-id]
                  [post/post-body d qp]
                  [post/post-ref-preview (:id d) refs batch-datetime]
                  ;; (when (= (:ws qp) "TLO")
                    [:<>
                     [:hr {:class ($posts/$post-tags-divider mobile (:tags_community d))}]
                     [tags (:id d) (:tags_community d) (:tags_community_links d)]]
                    ;; )
                  [post/post-footer index d qp roles logs]]}]])))




(defn post-op-mobile
  ([d index]
   (post-op-mobile d index true))
  ([d index full-id]
   (let [qp @(re-frame/subscribe [::posts-subs/query-params])
         roles @(re-frame/subscribe [::subs/roles])
         logs @(re-frame/subscribe [::posts-subs/all-moderation-log (:id d)])
         batch-datetime @(re-frame/subscribe [::posts-subs/batch-datetime])]
     [:div.row.no-pad.post-wrap.topic-wrap
      {:key (:id d)
       :class (str (when (or (= (:status d) "R") (= (:status d) "Q") (= (:status d) "S")) "removed")
                   " mobile")
       :style (post/post-mod-logs-border-style logs batch-datetime)}
      [:article.post.topic
       {:id (if (true? full-id)
              (subs (:id d) 1)
              (subs (:id d)  1 (string/index-of (:id d) (:thread d))))
        :class (when (or (= (:status d) "R") (= (:status d) "Q")) "removed")
        :itemScope true}
       [moderator-bar/op-btns d roles]
       [post/post-timestamp d]
       [post/post-header d qp full-id]
       [post/post-body d qp]
      ;;  [:footer.meta
      ;;   [post-screening-options d roles]
      ;;   [:div
      ;;    [post/post-signature d qp]
      ;;    " "
      ;;    [:div.thread-meta
      ;;     [post-replies d]
      ;;     " "
      ;;     [post/post-thread-refresh-replies-btn d]]]
      ;;   [:div.reactions
      ;;    [post/post-views d]
      ;;    [:span.divider " | "]
      ;;    [post/post-votes (:id d)]]
      ;;   [:div.context
      ;;    "board "
      ;;    [post/post-board-ruid d]
      ;;    " "
      ;;    [post/copy-post-board-ruid d]
      ;;    [:div.btn-group.btn-group-xs
      ;;     [post/post-all-in-board d]
      ;;     [post/post-board-execs d]]]
      ;;   [:span.postIdWrap
      ;;    "post "
      ;;    [post/post-id d]
      ;;    " "
      ;;    [post/copy-post-id d]]
      ;;   [post/post-screen-notes d]
      ;;   [post/post-moderator-logs index d logs]
      ;;   [post/post-filters d qp]]
       [post/post-footer index d qp roles logs]]])))


(defn sort-btns
  ([] [:<>])
  ([qp]
   [:ul.nav.nav-pills
    {:style {:float "right"}}
    [:li
     {:title "Thread Started" :role "presentation"
      :class (if (or (= (:sort qp) "submitted") (nil? (:sort qp))) "active" "")}
     [:a {:href (str "?" (cemerick.url/map->query
                          ;; (conj qp {:sort "submitted" :page 1})
                          (-> qp
                              (dissoc :bm)
                              (conj {:sort "submitted"}))))} [:i.glyphicon.glyphicon-time]]]
    [:li
     {:title "Thread Active / Last Replied" :role "presentation"
      :class (if (= (:sort qp) "replied") "active" "")}
     [:a {:href (str "?" (cemerick.url/map->query
                          ;; (conj qp {:sort "replied" :page 1})
                          (-> qp
                              (dissoc :bm)
                              (conj {:sort "replied"}))))}
      [:i.glyphicon.glyphicon-comment]
      [:i.glyphicon.glyphicon-time]]]
    [:li
     {:title "Total Views" :role "presentation"
      :class (if (= (:sort qp) "views") "active" "")}
     [:a {:href (str "?" (cemerick.url/map->query
                          ;; (conj qp {:sort "views" :page 1})
                          (-> qp
                              (dissoc :bm)
                              (conj {:sort "views"}))))}
      [:i.glyphicon.glyphicon-eye-open]
      [:i.glyphicon.glyphicon-sort-by-attributes-alt]]]
    [:li
     {:title "Total Replies" :role "presentation"
      :class (if (= (:sort qp) "replies") "active" "")}
     [:a {:href (str "?" (cemerick.url/map->query
                          ;; (conj qp {:sort "replies" :page 1})
                          (-> qp
                              (dissoc :bm)
                              (conj {:sort "replies"}))))}
      [:i.glyphicon.glyphicon-comment]
      [:i.glyphicon.glyphicon-sort-by-attributes-alt]]]]))


;; (defn posts-list []
;;   [:<>
;;    (let [data (re-frame/subscribe [::posts-subs/data])
;;         ;;  qp (re-frame/subscribe [::subs/query-params])
;;         ;;  qp (re-frame/subscribe [::posts-subs/query-params])
;;          qp @(re-frame/subscribe [::posts-subs/query-params])
;;          font-size @(re-frame/subscribe [::posts-subs/font-size])
;;          roles @(re-frame/subscribe [::subs/roles])]

;;      (if (empty? @data)
;;        [:div "No posts here"]
;;        (for [[index d] (map-indexed vector @data)]
;;   ;; (for [d @data]
;;          (cond
;;           ;;  (= (:level d) 1) [post-op d index @qp font-size]
;;           ;;  (= (:level d) 2) [post-reply d index @qp font-size]
;;            (= (:level d) 1)
;;           ;;  ^{:key (:id d)}
;;            [post-op d index qp roles font-size]
;;            (= (:level d) 2)
;;           ;;  ^{:key (:id d)}
;;            [post-reply d index qp roles font-size]))))])


;; (defn posts-list []
;;   (reagent/create-class
;;    {:display-name  "posts-list-component"
;;     :component-did-update
;;     (fn [this old-argv]
;;       (reagent/after-render clerk/after-render!))
;;     :reagent-render
;;     (fn []
;;       [:<>
;;        (let [data (re-frame/subscribe [::posts-subs/data])
;;              qp @(re-frame/subscribe [::posts-subs/query-params])
;;              font-size @(re-frame/subscribe [::posts-subs/font-size])
;;              roles @(re-frame/subscribe [::subs/roles])]
;;          (if (empty? @data)
;;            [:div "No posts here"]
;;            (for [[index d] (map-indexed vector @data)]
;;              (cond
;;                (= (:level d) 1)
;;                [post-op d index qp roles font-size]
;;                (= (:level d) 2)
;;                [post-reply d index qp roles font-size]))))])}))

(defn posts-list []
  (let [data (re-frame/subscribe [::posts-subs/data])
        mobile @(re-frame/subscribe [::subs/mobile])]
    (reagent/create-class
     {:display-name  "posts-list-component"
      :component-did-update
      (fn [this old-argv]
        (reagent/after-render clerk/after-render!))
      :reagent-render
      (fn []
        [:<>
         (if (empty? @data)
           [:div "No posts here"]
           (for [[index d] (map-indexed vector @data)]
             (cond
               (= (:level d) 1)
              ;;  (if mobile [post-op-mobile d index] [post-op d index])
               [post-op d index]
               (= (:level d) 2)
               [post-reply d index])))])})))




;; (defn posts-replies-list []
;;   [:<>
;;    (let [data @(re-frame/subscribe [::posts-subs/data])
;;          replies (filter #(= (:level %) 2) data)
;;          qp @(re-frame/subscribe [::posts-subs/query-params])
;;          font-size @(re-frame/subscribe [::posts-subs/font-size])
;;          roles @(re-frame/subscribe [::subs/roles])]
;;      (if (empty? replies)
;;        [:div "No replies here"]
;;        (for [[index d] (map-indexed vector replies)]
;;         ;;  ^{:key (:id d)}
;;          [post-reply d index qp roles font-size false])))])


;; (defn posts-replies-list []
;;   (reagent/create-class
;;    {:display-name  "posts-replies-list-component"
;;     :component-did-update
;;     (fn [this old-argv]
;;       (reagent/after-render clerk/after-render!))
;;     :reagent-render
;;     (fn []
;;       [:<>
;;        (let [data @(re-frame/subscribe [::posts-subs/data])
;;              replies (filter #(= (:level %) 2) data)
;;              qp @(re-frame/subscribe [::posts-subs/query-params])
;;              font-size @(re-frame/subscribe [::posts-subs/font-size])
;;              roles @(re-frame/subscribe [::subs/roles])]
;;          (if (empty? replies)
;;            [:div "No replies here"]
;;            (for [[index d] (map-indexed vector replies)]
;;         ;;  ^{:key (:id d)}
;;              [post-reply d index qp roles font-size false])))])}))

(defn posts-replies-list []
  (let [data (re-frame/subscribe [::posts-subs/data])
        qp @(re-frame/subscribe [::posts-subs/query-params])
        roles @(re-frame/subscribe [::subs/roles])]
    (reagent/create-class
     {:display-name  "posts-replies-list-component"
      :component-did-update
      (fn [this old-argv]
        (reagent/after-render clerk/after-render!))
      :reagent-render
      (fn []
        [:<>
         (let [replies (filter #(= (:level %) 2) @data)]
           (if (empty? replies)
             [:div "No replies here"]
             (for [[index d] (map-indexed vector replies)]
        ;;  ^{:key (:id d)}
               [post-reply d index false])))])})))






(def EID_TYPE_DESCRIPTIONS {"m:" "MIME Types (\"Accept\" browser header)"
                            "l:" "Languages (\"Accept Language\" browser header)"
                            "f:" "Fingerprint (BFP)"
                            "c:" "Cookie"
                            "d:" "Device Fingerprint (DFP)"
                            "g:" "Geo-Location"
                            "a:" "User Agent"})


(defn eid-type [eid]
  (let [description (get EID_TYPE_DESCRIPTIONS (subs eid 0 2))]
    [:<>
     [:dt "EID Type"]
     [:dd description]]))

(defn eid-full [eid]
  [:<>
   [:dt "Full EID"]
   [:dd
    {:style {:word-wrap "break-word"}}
    [:code eid]
    " "
    [:span.cp-id {:style {:position "relative"}}
     [:code
      [common/copier "copy full eid" eid "📋"]]]]])

(defn eid-original-ruid [eid]
  (let [eid-metadata (re-frame/subscribe [::posts-subs/eid-metadata eid])]
    [:<>
     [:dt "Original ruid"]
     [:dd [:code (:orig_ruid @eid-metadata)]]]))

(defn eid-timespan-logs [eid]
  (let [eid-logs (re-frame/subscribe [::posts-subs/eid-logs])]
    [:<>
     (when (some? @eid-logs)
       [:button.btn.btn-default {:disabled true} "Logs:"]
       [:<>
        [:button.btn.btn-default
         {:disabled true}
         [:em "First seen: "]
         [:strong (:first_seen @eid-logs)]]
        [:button.btn.btn-default
         {:disabled true}
         [:em "Last seen: "]
         [:strong (:last_seen @eid-logs)]]])]))

(defn eid-screening-status [eid]
  (let [;; eid-screening (re-frame/subscribe [::posts-subs/eid-screening])
        eid-screening (re-frame/subscribe [::posts-subs/screning-status eid])
        roles @(re-frame/subscribe [::subs/roles])]
    [:div {:class "btn-group"}
     [:button.btn.btn-default {:disabled true} "Screens:"]
     (cond (and (some? @eid-screening) (> (:n_total @eid-screening) 0))
           [:<>
            (when (> (:n_enabled @eid-screening) 0)
              [:a.btn.btn-danger
               {:title "Click to see all screens with this scope"
                :href (str "/screening?" (cemerick.url/map->query {:scope eid}))}
               [:strong (str "\n\t\t\t" (:n_enabled @eid-screening) " enabled\n\t\t")]])
            (when (> (:n_disabled @eid-screening) 0)
              [:a.btn.btn-warning
               {:title "Click to see all screens with this scope"
                :href (str "/screening?" (cemerick.url/map->query {:scope eid}))}
               [:strong (str "\n\t\t\t" (:n_disabled @eid-screening) " disabled\n\t\t")]])]
           :else [:<>
                  [:button.btn.btn-default {:disabled true} [:strong "not screened"]]
                  (when (contains? roles "screener")
                    [:a.btn.btn-primary
                     {:href (str "/screening/create-new?" (cemerick.url/map->query {:scope eid}))}
                     "\n\t\tCreate new screen\n\t"])])]))

(defn eid-metadata [eid]
  (re-frame/dispatch [::posts-events/http-get-scope-eid-metadata eid])
  (re-frame/dispatch [::posts-events/http-get-log-timespan eid]) ;;not eid, ruid
  (re-frame/dispatch [::posts-events/http-get-screening-status eid]) ;;not eid, ruid
  [:div
   [:dl.dl-horizontal
    [eid-type eid]
    [eid-full eid]
    [eid-original-ruid eid]]
   [:div.btn-group
    [eid-timespan-logs eid]]
   [:br]
   [:br]
   [:div.btn-group
    [eid-screening-status eid]]
   [:br]
   [:br]])




(defn ip-metadata [eid]
  (re-frame/dispatch [::posts-events/http-get-log-timespan (str "^" eid)]) ;; "^" should be displayed everywhere
  (re-frame/dispatch [::posts-events/http-get-screening-status (str "^" eid)]) ;; "^" should be displayed everywhere
  [:div
   [:div.btn-group
    [eid-timespan-logs eid]]
   [:br]
   [:br]
   [:div.btn-group
    [eid-screening-status (str "^" eid)]]
   [:br]
   [:br]])


(defn cc-metadata [eid]
  (re-frame/dispatch [::posts-events/http-get-log-timespan (str ":" eid)]) ;; "^" should be displayed everywhere
  (re-frame/dispatch [::posts-events/http-get-screening-status (str ":" eid)]) ;; "^" should be displayed everywhere
  [:div
   [:div.btn-group
    [eid-timespan-logs eid]]
   [:br]
   [:br]
   [:div.btn-group
    [eid-screening-status (str ":" eid)]]
   [:br]
   [:br]])


(defn header-metadata [eid]
  ;; TODO: consider moving "http-get-screening-status" to thread flow
  ;; also consider swapping header-metadata and thread-metadata function names, they are called from thread and header panel respectively
  (re-frame/dispatch [::posts-events/http-get-screening-status eid])
  [eid-screening-status eid])

(defn thread-metadata [eid]
  ;; "http-get-screening-status" now happens in "get-header-flow"
  ;; (re-frame/dispatch [::posts-events/http-get-screening-status eid])
  [eid-screening-status eid])





(defn posts-layout [query-params]
  (let [font-size @(re-frame/subscribe [::posts-subs/font-size])]
    [:div.posts {:class (str "font-size-" font-size)}
     [common/bm-pager ::posts-subs/batch-meta]
     (cond (= (:layout @query-params) "table")
           [posts-table]
           (= (:layout @query-params) "table2")
           [posts-table-2]
           :else
           [posts-list])
     [common/bm-pager ::posts-subs/batch-meta]]))


;; TODO: Rename these
(defn posts-layout-no-pager [query-params]
  (let [font-size @(re-frame/subscribe [::posts-subs/font-size])]
    [:div.posts {:class (str "font-size-" font-size)}
     (cond (= (:layout @query-params) "table")
           [posts-table]
           (= (:layout @query-params) "table2")
           [posts-table-2]
           :else
           [posts-list])]))


(defn posts-replies-layout [query-params]
  ;;  12/21/22 when adding table view to thread panel, noticed that posts were reloading - even though switching layout shouldn't do that.
  ;;  The reason why it reloads in thread is because of :pq-check set to false in thread flow
  (let [font-size @(re-frame/subscribe [::posts-subs/font-size])]
    [:div.posts {:id "replies"
                 :class (str "font-size-" font-size)}
     [common/bm-pager ::posts-subs/batch-meta]
     (cond (= (:layout @query-params) "table")
           [posts-table]
           (= (:layout @query-params) "table2")
           [posts-table-2]
           :else
           [posts-replies-list])
     [common/bm-pager ::posts-subs/batch-meta]]))


(defn posts-pager-n-layout [query-params]
  (let [font-size @(re-frame/subscribe [::posts-subs/font-size])]
    [:div.posts {:class (str "font-size-" font-size)}
     [common/pager ::posts-subs/meta]
     (cond (= (:layout @query-params) "table")
           [posts-table]
           (= (:layout @query-params) "table2")
           [posts-table-2]
           :else
           [posts-list])
     [common/pager ::posts-subs/meta]]))


(defn posts-cc-panel []
  (let [route-params (re-frame/subscribe [::subs/route-params])
        ;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])]
    ;; must merge route and query params here
    ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced (merge @route-params @query-params)])
    (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced (merge @route-params @query-params)])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])

    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      ;; {:style {:width (if (= (:layout @query-params) "table") "100%" "748px")}}
      ;; TODO: no table view
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
    ;; [:h1 [:small " Scopes : Website " [:code ".TLO"]]]
      [:nav
       {:aria-label "breadcrumb"}
       [:ol.breadcrumb
        [:li.breadcrumb-item [:a {:href (str "/" route-prefix)} "Iris"]]
        [:li.breadcrumb-item "cc"]
        [:li.breadcrumb-item.active
         {:aria-current "page"}
         ":" (:cc @route-params)]]]

      [:h1 [:code ":" (:cc @route-params)] " " [:small "cc"]]

      (when-let [cc (:cc @route-params)]
        [cc-metadata cc])

      [:div#content
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "Posts"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]
        ;;  [:div.posts
        ;; ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]

        ;;   (cond (= (:layout @query-params) "table")
        ;;         [posts-table]
        ;;         (= (:layout @query-params) "table2")
        ;;         [posts-table-2]
        ;;         :else
        ;;         [posts-list])

        ;; ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]]
         [posts-layout query-params]

         ]]]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))


(defn posts-ip-panel []
  (let [route-params (re-frame/subscribe [::subs/route-params])
        ;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])]

    ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced (merge @route-params @query-params)])
    (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced (merge @route-params @query-params)])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      ;; {:style {:width (if (= (:layout @query-params) "table") "100%" "748px")}}
      ;; TODO: no table view yet
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
    ;; [:h1 [:small " Scopes : Website " [:code ".TLO"]]]
      [:nav
       {:aria-label "breadcrumb"}
       [:ol.breadcrumb
        [:li.breadcrumb-item [:a {:href (str "/" route-prefix)} "Iris"]]
        [:li.breadcrumb-item "ip"]
        [:li.breadcrumb-item.active
         {:aria-current "page"}
         (str "^" (:ip @route-params))]]]

      [:h1 [:code (str "^" (:ip @route-params))] " " [:small "ip"]]

      (when-let [ip (:ip @route-params)]
        [ip-metadata ip])

      [:div#content
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "Posts"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]
        ;;  [:div.posts
        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]

        ;;   (cond (= (:layout @query-params) "table")
        ;;         [posts-table]
        ;;         (= (:layout @query-params) "table2")
        ;;         [posts-table-2]
        ;;         :else
        ;;         [posts-list])

        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]]
         [posts-layout query-params]

         ]]]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))





;; (def posts-eid-panel-raid (reagent/atom nil))

(defn posts-eid-panel-nav-breadcrumbs-h1 [eid]
  (let [raid-len (re-frame/subscribe [::subs/raid-len])
        raid (hench/eid-len-raid eid @raid-len)]
    [:div {:style {:margin "20px 0"}}
     [:nav
      {:aria-label "breadcrumb"}
      [:ol.breadcrumb
       [:li.breadcrumb-item [:a {:href (str "/" route-prefix)} "Iris"]]
       [:li.breadcrumb-item "eid"]
       [:li.breadcrumb-item.active
        {:aria-current "page"}
        raid]]]
     [:h1 [:code raid] " " [:small "eid"]]]))

(defn posts-eid-panel []
  (let [route-params (re-frame/subscribe [::subs/route-params])
        ;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])]

    ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced (merge @route-params @query-params)])
    (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced (merge @route-params @query-params)])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])

    ;; (when-let [eid (:eid @route-params)]
    ;;   (go (reset! posts-eid-panel-raid (<! (hench/eid-to-raid eid))))
    ;;   ;; (re-frame/dispatch [::posts-events/http-get-scope-eid-metadata eid])
    ;;   ;; (re-frame/dispatch [::posts-events/http-get-log-timespan eid]) ;;not eid, ruid
    ;;   ;; (re-frame/dispatch [::posts-events/http-get-screening-status eid]) ;;not eid, ruid
    ;;   )
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      ;; {:style {:width (if (= (:layout @query-params) "table") "100%" "748px")}}
      ;; TODO: no table view yet, not sure if needed
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      ;; [:nav
      ;;  {:aria-label "breadcrumb"}
      ;;  [:ol.breadcrumb
      ;;   [:li.breadcrumb-item [:a {:href (str "/" route-prefix)} "Iris"]]
      ;;   [:li.breadcrumb-item "eid"]
      ;;   [:li.breadcrumb-item.active
      ;;    {:aria-current "page"}
      ;;    @posts-eid-panel-raid]]]
      ;; [:h1 [:code @posts-eid-panel-raid] " " [:small "eid"]]
      (when-let [eid (:eid @route-params)]
        [:<>
         [posts-eid-panel-nav-breadcrumbs-h1 eid]
         [eid-metadata eid]])

      [:div#content
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "Posts"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]
        ;;  [:div.posts
        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]

        ;;   (cond (= (:layout @query-params) "table")
        ;;         [posts-table]
        ;;         (= (:layout @query-params) "table2")
        ;;         [posts-table-2]
        ;;         :else
        ;;         [posts-list])

        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]]
         [posts-layout query-params]

         ]]]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))






(defn posts-panel-h1 [qp]
  (let [filter-data (re-frame/subscribe [::posts-subs/filter-data])]
    [:<>
     [:h1
      [:small
       "Scopes : "
       (for [[index d] (map-indexed vector @filter-data)]
         ;; ^{:key (str
         ;;         (:label d)
         ;;         (:value d))}
         [:<>
          [:span (str (when (and (> index 0) (> (count @filter-data) 1)) " : ") (:label d))]
          [:code {:style {:margin "2px 4px"}} (:value d)]
          (when (not= (:param d) :ws)
            [:a {:href (str "?" (cemerick.url/map->query (dissoc qp (:param d))))}
             [:sup
              [:i.glyphicon.glyphicon-remove-circle]]])])]]

     (when-let [empty-filters (seq (keep #(when (empty? (:value %)) (:label %)) @filter-data))]
       [:div.alert.alert-danger
        [:span "⚠️ Empty filters: "]
        [:strong (interpose ", " empty-filters)]])]))


;; not used!
;; (defn admin-moderation-logs [ws]
;;   (go
;;     (let [logs (<p! (fb/<p-get-admin-moderation-logs ws))]
;;       ;; (println "moderation logs::" (vec (vals logs)))
;;       ;; (doseq [[k v] logs]
;;       ;;   (println (str k ": " v))
;;       ;;   (re-frame/dispatch [::posts-events/set-admin-moderation-log v])
;;       ;; )
;;       (re-frame/dispatch [::posts-events/set-admin-moderation-logs (vec (vals logs))])
;;       ))

;;   [:<>])

(defn admin-all-moderation-logs [ws ruid]
  (go
    (let [logs (<p! (data/get-admin-all-moderation-logs-promise ws ruid))]
      ;; (doseq [[k v] logs]
      ;;   (println "ALL:" (reduce conj [] v) )
      ;;   ;; set-admin-all-moderation-logs
      ;;   )
      (re-frame/dispatch [::posts-events/set-admin-all-moderation-logs ruid (vec (vals logs))])))
  [:<>])

;; TODO: consider dereferencing query params in the let block
(defn posts-panel []
  (let [;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])]


    (re-frame/dispatch [::posts-events/set-posts-filters-from-qp @query-params])



    ;; (re-frame/dispatch [::posts-events/http-get-post-list @query-params])
    ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced @query-params])
    ;; TODO: use debounced version of lit batch??
    ;; (re-frame/dispatch [::posts-events/http-get-post-list-batch @query-params])
    (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced @query-params])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
    ;;  [admin-moderation-logs (:ws @query-params)]
    ;;  [admin-all-moderation-logs (:ws @query-params) "@juuf+1mNwL42f"]

     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width
              ;;  (when (= (:layout @query-params) "table") "100%")
               (when (or (= (:layout @query-params) "table")
                         (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      [posts-panel-h1 @query-params]
      [:div#content
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "Posts"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]

;; (let [font-size @(re-frame/subscribe [::posts-subs/font-size])]
;;   [:div.posts {:class (str "font-size-" font-size)}

;;    [common/bm-pager ::posts-subs/batch-meta]

;;    (cond (= (:layout @query-params) "table")
;;          [posts-table]
;;          (= (:layout @query-params) "table2")
;;          [posts-table-2]
;;          :else
;;          [posts-list])

;;    [common/bm-pager ::posts-subs/batch-meta]])

         [posts-layout query-params]]]]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))







(defn latest-panel []

  (let [query-params (re-frame/subscribe [::posts-subs/query-params])]


    (re-frame/dispatch [::posts-events/set-posts-filters-from-qp @query-params])

;; NOTE: this debounce is not necessary here, there is a problem with default webite sync - get post list runs before it actually syncs so we have multiple loads. It needs to wait.
    ;; also we have next page btns - need to get rid of them.

    ;; (re-frame/dispatch [::posts-events/http-get-latest-post-list (merge @query-params {:level 1 :limit 75})])

    (re-frame/dispatch [::posts-events/http-get-latest-post-list @query-params])

    ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced @query-params])
    ;; TODO: use debounced version of lit batch??
    ;; (re-frame/dispatch [::posts-events/http-get-post-list-batch @query-params])
    ;; (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced @query-params])
    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params {:level false :route "/last-25.php"}]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width
              ;;  (when (= (:layout @query-params) "table") "100%")
               (when (or (= (:layout @query-params) "table")
                         (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      [posts-panel-h1 @query-params]

      [:div#content
       [:main#topics
        ;; [:div.topics-head
        ;;  [sort-btns @query-params]]
        [:h2 "Latest Posts" " " [:small "(Published OPs only)"]]
        [search-inputs-embed]
        [:section#posts
        ;;  [limit-btns @query-params]
        ;;  [text-resizer]



         [posts-layout-no-pager query-params]]]]]

     [common/message ::subs/message {:personal-moderator-logs true}]]))








(defn header-h1 []
  (let [header @(re-frame/subscribe [::posts-subs/header])]
    [:h1
     "Company "
     [:code (:ruid header)]
     " "
     [:sup
      [:code
       (when-let [ruid (:ruid header)]
         [common/copier "copy board ruid" (subs ruid 0 (string/index-of ruid ".")) "📋"])]]
     " "
     [:small (str "(" (:title header) ")")]
     [:small
      [:a
       {:target "google",
        :title "Google search executives",
        :href (str "https://www.google.com/search?q=" (cemerick.url/url-encode (:title header)) "+executives")}
       [:i.glyphicon.glyphicon-plane]]]]))


;; (defn on-submit-op-form [e]
;;   (.preventDefault e)

;;   (let [header @(re-frame/subscribe [::posts-subs/header])
;;         title (.-value (.querySelector js/document "#op-form #title"))
;;         text (.-value (.querySelector js/document "#op-form #text"))
;;         name (.-value (.querySelector js/document "#op-form #name"))
;;         fp @(re-frame/subscribe [::subs/fp])
;;         dfp @(re-frame/subscribe [::subs/dfp])
;;         data {:re (:ruid header)
;;               :title title
;;               :text text
;;               :signature name
;;               :fp fp
;;               :dfp dfp}]
;;     (re-frame/dispatch [::posts-events/post-create data])))

(defn op-form []
  (let [header @(re-frame/subscribe [::posts-subs/header])]
    ;; [forms/op-form (:ruid header)]
    [forms/op-form {:board (:ruid header)}]))







(defn posts-header-panel []

  (let [;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])
        route-params (re-frame/subscribe [::subs/route-params])]

    ;; (re-frame/dispatch [::posts-events/http-get-header (str "/" (:header @route-params))])
    ;; ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced (merge @query-params {:board (str "/" (:header @route-params)) :level 1})])
    ;; (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced (merge @query-params {:board (str "/" (:header @route-params)) :level 1})])

    (re-frame/dispatch [::posts-events/http-get-header-flow
                        (merge @query-params {:board (str "/" (:header @route-params)) :level 1})
                        (str "/" (:header @route-params))])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params {:ws false :level false}]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      ;; [:h1 [:small " Scopes : Website " [:code (str "." (:ws @query-params))]]]
      [header-h1]
      ^{:key (str (:ws @query-params) (str "/" (:header @route-params)))} [social-bar (:ws @query-params) "node" (str "/" (:header @route-params))]
      [search-inputs-embed]
      [:div#content
       [company-panel]
       (when-let [header @(re-frame/subscribe [::posts-subs/header])]
         [:div.panel.no-border
          [:a.btn.btn-primary
           {:href "#comment_form"}
           [:i.glyphicon.glyphicon-arrow-down]
           " OP form\n\t"]
          [:a.btn.btn-primary
           {:href (str route-prefix "/posts?board=" (:ruid header))}
           [:i.glyphicon.glyphicon-list]
           " All posts\n\t"]

          ;; [:div.btn-group
          ;;  [:button.btn.btn-default {:disabled ""} "Screens:"]
          ;;  [:button.btn.btn-default {:disabled ""} [:strong "not screened"]]
          ;;  [:a.btn.btn-primary
          ;;   {:href (str "/screening/create-new?scope=" (:ruid header) "&kind=full")}
          ;;   "\n\t\tCreate new screen\n\t"]]

          [thread-metadata (:ruid header)]])
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "OPs"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]
        ;;  [:div.posts
        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]

        ;;   (cond (= (:layout @query-params) "table")
        ;;         [posts-table]
        ;;         (= (:layout @query-params) "table2")
        ;;         [posts-table-2]
        ;;         :else
        ;;         [posts-list])

        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]]

         [posts-layout query-params]]]]
      [op-form]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))





(defn posts-op []
  [:<>
   (let [data @(re-frame/subscribe [::posts-subs/data])
         d (filter #(= (:level %) 1) data)
         font-size @(re-frame/subscribe [::posts-subs/font-size])]
     (when (not-empty d)
      ;;  ^{:key (:id (first d))}
       [:div {:class (str "font-size-" font-size)}
        [post-op (first d) 0 false]]))])




;; (defn on-submit-reply-form [e]
;;   (.preventDefault e)

;;   ;; TODO: use reg-sub for getting OP from data (filter in sub)
;;   (let [data @(re-frame/subscribe [::posts-subs/data])
;;         d (first (filter #(= (:level %) 1) data))
;;         text (.-value (.querySelector js/document "#reply-form #text"))
;;         name (.-value (.querySelector js/document "#reply-form #name"))
;;         fp @(re-frame/subscribe [::subs/fp])
;;         dfp @(re-frame/subscribe [::subs/dfp])
;;         data {:re (:id d)
;;               :text text
;;               :signature name
;;               :fp fp
;;               :dfp dfp}]
;;     (re-frame/dispatch [::posts-events/post-create data])))

(defn reply-form []
  (let [data @(re-frame/subscribe [::posts-subs/data])
        d (first (filter #(= (:level %) 1) data))]
    [forms/reply-form d]))



(defn thread-h1 []

  (let [data @(re-frame/subscribe [::posts-subs/data])
        d (first (filter #(= (:level %) 1) data))]
    [:h1
     "\n\tThread "
     [:code (:thread d)]
     "\n\tre. "
     [:a
      {:href (str route-prefix (:forum d))}
      [:code (:forum d)]]
     [:sup
      [:code
       (when-let [ruid (:forum d)]
         [common/copier "copy board ruid" (subs ruid 0 (string/index-of ruid ".")) "📋"])]]
     [:small
      [:a
       {:target "google",
        :href
        (str "https://www.google.com/search?q=" (cemerick.url/url-encode (:board_name d)) "+executives")
        }
       [:i.glyphicon.glyphicon-search]]]]))



(defn thread-num-replies []
  (let [data @(re-frame/subscribe [::posts-subs/data])
        num-replies (- (count data) 1)]
    (when (> num-replies 0)
      [:div.replies-head
       [:h2.comments-head (str num-replies " " (if (> num-replies 1) "replies" "reply") "\n\t\t\ttotal\n\t\t")]])))



(defn thread-panel []

  (let [query-params (re-frame/subscribe [::posts-subs/query-params])
        route-params (re-frame/subscribe [::subs/route-params])]

    ;; TODO: rename to "http-get-thread-flow"
    (re-frame/dispatch [::posts-events/http-get-thread (merge @query-params {:board (str "+" (:id @route-params)) :level 2})])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params {:ws false :level false}]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [reply-alert (:ws @query-params) (str "+" (:id @route-params)) (merge @query-params {:board (str "+" (:id @route-params)) :level 2})]
     [:div#page-body.container
      ;; {:style {:width "748px"}}
      ;; TODO: Table view is not enabled for threads yet!!
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      [thread-h1]
      ^{:key (str (:ws @query-params) (str "+" (:id @route-params)))} [social-bar (:ws @query-params) "thread" (str "+" (:id @route-params))]
      [search-inputs-embed]
      [:div#content
      ;;  [company-panel]
       [:main#topics
        [:div.topics-head
        ;;  [sort-btns @query-params]
         ]
        ;; [:h2 "Posts"]
        [:section#posts
        ;;  [limit-btns @query-params]
        ;;  [text-resizer]
         [posts-op]


         [:div.panel.no-border.row.no-pad
          [:div.col-xs-12.col-sm-9
           [:a.btn.btn-primary
            {:href "#comment_form"}
            [:i.glyphicon.glyphicon-arrow-down]
            " Reply form\n\t\t"]



           [header-metadata (str "+" (:id @route-params))]
          ;;  [:div.btn-group
          ;;   [:button.btn.btn-default {:disabled ""} "Screens:"]
          ;;   [:button.btn.btn-default {:disabled ""} [:strong "not screened"]]
          ;;   [:a.btn.btn-primary
          ;;    {:href (str "/screening/create-new?scope=%2B" (:id @route-params) "&kind=full")}
          ;;    "\n\t\tCreate new screen\n\t"]]
           ]
          [:div.col-xs-12.col-sm-3
           [thread-alert-btn]]]

         [thread-num-replies]
         [limit-btns @query-params]

;; ;; TODO: posts-op above is missing font-size class
;;         ;;  TODO: font-size subscription is triggering thread data reload
        ;;  IT MUST BE IN ITS OWN FUNCTION NOT TO RELOAD
;;          (let [font-size @(re-frame/subscribe [::posts-subs/font-size])]
;;            [:div.posts {:id "replies"
;;                         :class (<class $posts/font-size font-size)
;;                         }
;;           ;; [common/pager ::posts-subs/meta]
;;             [common/bm-pager ::posts-subs/batch-meta]

;;           ;;  12/21/22 when adding table view to thread panel, noticed that posts were reloading - even though switching layout shouldn't do that.
;;           ;;  The reason why it reloads in thread is because of :pq-check set to false in thread flow
;;           ;; [posts-replies-list]

;;             (cond (= (:layout @query-params) "table")
;;                   [posts-table]
;;                   (= (:layout @query-params) "table2")
;;                   [posts-table-2]
;;                   :else
;;                   [posts-replies-list])

;;           ;; [common/pager ::posts-subs/meta]
;;             [common/bm-pager ::posts-subs/batch-meta]]
;;            )
         [posts-replies-layout query-params] ;; must be used not to reload
         ]]]
      [reply-form]]
     [common/message ::subs/message {:personal-moderator-logs true}]]))



(defn user-panel []
  (let [;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])
        route-params (re-frame/subscribe [::subs/route-params])]

    ;; (re-frame/dispatch [::posts-events/http-get-post-list-debounced (merge (merge @query-params @route-params))])
    (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced (merge (merge @query-params @route-params))]) ;; TODO: why is there merge twice??

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      ;; {:style {:width "748px"}}
      ;; TODO: no table view yet, not sure if needed here???
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      ;; [:h1 [:small " Scopes : Website " [:code (str "." (:ws @query-params))]]]
      [:h1 [:code (str "=" (:user @route-params))] " " [:small "user"]]
      [:div#content
      ;;  [company-panel]
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "Posts"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]
        ;;  [:div.posts
        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]

        ;;   (cond (= (:layout @query-params) "table")
        ;;         [posts-table]
        ;;         (= (:layout @query-params) "table2")
        ;;         [posts-table-2]
        ;;         :else
        ;;         [posts-list])

        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]]

         [posts-layout query-params]

         ]]]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))



(defn hashtag-panel []
  (let [query-params (re-frame/subscribe [::posts-subs/query-params])
        route-params (re-frame/subscribe [::subs/route-params])]

    (re-frame/dispatch [::posts-events/http-get-post-list-batch-debounced (merge @query-params @route-params)])

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [filter-top-bar @query-params {:ws false}]
     [display-top-bar @query-params]
     [posts-logs-switch]
     [:div#page-body.container
      ;; {:style {:width "748px"}}
      ;; TODO: no table view yet!
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      [:h1 "Hashtag " [:code (str "#" (:tag @route-params))]]
      ^{:key (str (:ws @query-params) (str "+" (:id @route-params)))} [social-bar (:ws @query-params) "thread" (str "+" (:id @route-params))]
      [search-inputs-embed]
      [:div#content
       [:main#topics
        [:div.topics-head
         [sort-btns @query-params]]
        [:h2 "Posts"]
        [:section#posts
         [limit-btns @query-params]
        ;;  [text-resizer]
        ;;  [:div.posts
        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]

        ;;   (cond (= (:layout @query-params) "table")
        ;;         [posts-table]
        ;;         (= (:layout @query-params) "table2")
        ;;         [posts-table-2]
        ;;         :else
        ;;         [posts-list])

        ;;   ;; [common/pager ::posts-subs/meta]
        ;;   [common/bm-pager ::posts-subs/batch-meta]]

         [posts-layout query-params]

         ]]]]
    ;;  [common/message ::posts-subs/message]
     [common/message ::subs/message {:personal-moderator-logs true}]]))






(defn search-results-meta-message [page limit meta]
  [:p
   (cond (> (:n_found @meta) 0)
         [:<>
          [:span (str
                  "Showing results " (if (= (int page) 1) 1 (* (- (int page) 1) limit)) " to " (if (> (* (int page) limit) (:n_found @meta)) (:n_found @meta) (* (int page) limit)) ". "
                  "Total " (:n_found @meta) " results found.")]

          (when (> (:n_found @meta) globals/POSTS_SEARCH_MAXCOUNT_DEFAULT)
            [:a {:href "#total-warning"} [:sup "*"]])
          [:span (str " Search took " (:t_seconds @meta) " seconds.")]]
         (= (:n_found @meta) 0)
         "No results found."
         (some? (:message @meta))
         (:message @meta)
         :else
         "Searching...")])

(defn search-results-meta-max-count-options [qp]
  [:div#total-warning.alert.alert-warning
   [:sup "*"]
   " "
   [:small
    [:strong "Warning:"]
    " The number of results found you see above may be a wild guesssss."
    [:br]
    "\n\t\t\tTo get an accurate count, try with a larger maxcount:\n\t\t\t"
    [:a {:href (str "?" (cemerick.url/map->query (conj @qp {:maxcount 1000})))} "1000"]
    " | \n\t\t\t"
    [:a {:href (str "?" (cemerick.url/map->query (conj @qp {:maxcount 2500})))} "2500"]
    " | \n\t\t\t"
    [:a {:href (str "?" (cemerick.url/map->query (conj @qp {:maxcount 5000})))} "5000"]
    ".\n\t\t\t"
    [:br]
    "\n\t\t\tYou may experience a timeout for very large numbers.\n\t\t"]])


(defn search-results-meta [page limit qp]
  (let [meta (re-frame/subscribe [::posts-subs/meta])]
    [:<>
     [search-results-meta-message page limit meta]
     (when (> (:n_found @meta) globals/POSTS_SEARCH_MAXCOUNT_DEFAULT)
       [search-results-meta-max-count-options qp])]))


(defn search-panel []
  (let [query-params (re-frame/subscribe [::posts-subs/query-params])
        q (or (:q @query-params) "")
        index (or (:index @query-params) "admin")
        order (or (:order @query-params) "desc")
        limit (:limit @query-params)
        page (or (:page @query-params) 1)
        ws (or (:ws @query-params) "TLO")
        maxcount (int (:maxcount @query-params))]

    (when-not (empty? q)
      (re-frame/dispatch [::posts-events/set-posts-filters-from-qp @query-params])
      (re-frame/dispatch [::posts-events/http-post-search ws index limit order page q maxcount]))

    (re-frame/dispatch [::posts-events/personal-moderation-logs (:ws @query-params)])
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [personal-moderator-logs]
     [:div#page-body.container
      {:class
      ;;  (<class $posts/container)
       $posts/$container
       :style {:width (when (or (= (:layout @query-params) "table")
                                (= (:layout @query-params) "table2")) "100%")}}
      [common/spinner]
      [:h1 "Admin Post Search"]
      [:div#content
       [:div
        {:style {:margin "30px 0 50px"}}
        [:form#search.form-inline.mr-auto {:key (str q index order)}
         [:input.form-control
          {:size "50"
           :default-value q
           :id "q"
           :name "q"
           :type "text"}]
         " "
         [:select.form-control
          {:id "ws"
           :name "ws"
           :defaultValue ws}
          (for [ws (:websites @globals/jwt-payload)]
            [:option ws])]
         " "
         [:input.btn.btn-primary {:value "Search"
                                  :type "submit"
                                  :on-click (fn [e]
                                              (.preventDefault e)
                                              (let [q (.-value (js/document.querySelector "form#search #q"))
                                                    ws (.-value (js/document.querySelector "form#search #ws"))
                                                    order (.-value (js/document.querySelector "form#search input[name=order]:checked"))
                                                    qp-str (str (routes/url-for :search) "?index=" index "&order=" order "&ws=" ws "&q=" q)]
                                                (routes/route-to! qp-str)))}]
         [:br]
         "\n\torder:\n\t \n\t"
         [:input {:default-checked (= order "desc")
                  :name "order"
                  :type "radio"
                  :value "desc"}]
         "newest first\n\t \n\t"
         [:input {:default-checked (= order "asc")
                  :name "order"
                  :type "radio"
                  :value "asc"}]
         "oldest first\n"]]

       (when (empty? q)
         [:div#content
          [:h3#fields "Field operators"]
          (when (= index "public")
            [:<>
             [:p [:a {:href "?index=admin#fields"} "admin post search"] " | " [:span "public post search"]]
             [:pre
              "\n  nick:        Atom    Post ID w/ thread stripped (prefix optional). E.g. `nick:OP`, `nick:@OP`\n  thread:      Atom    Thread ID (prefix optional). E.g. `thread:abcde`, `thread:+abcde`\n  forum:       Atom    Forum slug or path. E.g. `forum:intel`, `forum:/intel`\n  title:       Text    Full text search in censored title field\n  text:        Text    Full text search in censored text field\n  signed:      Text    Full text search in censored signature field\n  tag:         Atom    Hashtag (prefix optional). E.g. `tag:h1b`, `tag:#h1b`\n  ref:         Atom    Reference to post (@OP+abcde), thread (+abcde) or forum (/intel) parsed in title or text. Prefix ('@', '+' or '/') required\n  level:       Number  1 for OPs, 2 for replies\n  posted:      Date    ISO-style date, e.g. 2019-12-31, or `posted:today`, `posted:yesterday`\n  active:      Date    ISO-style date, e.g. 2019-12-31, or `active:today', `active:yesterday`\n  nreplies:    Number  Number of replies\n  nwords:      Number  Number of words in title + text\n  nparagraphs: Number  Number of paragraphs in text\n  ntags:       Number  Number of hashtags parsed\n  nrefs:       Number  Number of refs parsed (post + board)\n\n"]])
          (when (= index "admin")
            [:<>
             [:p "admin post search" " | " [:a {:href "?index=public#fields"} "public post search"]]
             [:pre
              "\n  nick:        Atom    Post ID w/ thread stripped, e.g. `nick:OP`, `nick:@OP`\n  thread:      Atom    Thread ID, e.g. `thread:abcde`, `thread:+abcde`\n  forum:       Atom    Forum slug or path, e.g. `forum:intel`, `forum:/intel`\n  title:       Text    Full text search in raw title field\n  text:        Text    Full text search in raw text field\n  signed:      Text    Full text search in raw signature field\n  tag:         Atom    Hashtag, e.g. `tag:h1b`, `tag:#h1b`\n  ref:         Atom    Reference to post (@OP+abcde), thread (+abcde) or forum (/intel) parsed in title or text. Prefix ('@', '+' or '/') required\n  status:      Atom    s|p|r|q|t (s=submitted, p=published, r=removed, q=quarantined, t=thread removed)\n  level:       Number  1 for OPs, 2 for replies\n  posted:      Date    ISO-style date, e.g. 2019-12-31, or `posted:today`, `posted:yesterday`\n  hour:        Number  Posting time number of hours since midnight UTC, e.g. `hour:23` = posted between 23:00 and 23:59 UTC\n  d3:          Number  Posting time grouped into 3 buckets: `d3:1` = 0-8 UTC, `d3:2` = 8-16 UTC, `d3:3` = 16-24 UTC\n  d4:          Number  Posting time grouped into 4 buckets: `d4:1` = 0-6 UTC, `d4:2` = 6-12 UTC, `d4:3` = 12-16 UTC, `d4:4` = 16-24 UTC\n  updated:     Date    ISO-style date, e.g. 2019-12-31, or `updated:today`, `updated:yesterday`\n  published:   Date    ISO-style date, e.g. 2019-12-31, or `published:today`, `published:yesterday`\n  active:      Date    ISO-style date, e.g. 2019-12-31, or `active:today', `active:yesterday`
  ip:          Atom    Author's IP address
  cc           Atom    Author's country code (based on IP). Unknown country: `cc:ZZ`
  cookie:      Atom    Author's cookie, e.g. `cookie:uB9`, `cookie:*uB9`
  sid:         Atom    Author's session ID (deprecated, same results as cookie)
  bfp:         Atom    Author's browser fingerprint, e.g. `bfp:a_N`, `bfp:&a_N`
  dfp:         Atom    Author's device fingerprint, e.g. `dfp:n2zQ`, `dfp:~n2zQ`
  uid:         Atom    Author's user ID. E.g. `uid:boris`, `uid:sarajevo@gmail.com`\n  staff:       Atom    yes|no (also works: y|n, true|false, t|f, 1|0)\n  qc:          Atom    yes|no (also works: y|n, true|false, t|f, 1|0)\n  qc_by:       Atom    Moderator UID who checked QC. E.g. `qc_by:boris`, `qc_by:margotstrasna@gmail.com`\n  nreplies:    Number  Number of replies\n  nviews:      Number  Number of views\n  ntags:       Number  Number of hashtags parsed\n  nrefs:       Number  Number of refs parsed (post + board)\n  nprefs:      Number  Number of refereces to posts parsed\n  nbrefs:      Number  Number of references to boards/forums parsed\n  nchars:      Number  Number of characters in title + text\n  nwords:      Number  Number of words in title + text\n  nsentences:  Number  Number of sentences in title + text\n  nparagraphs: Number  Number of paragraphs in text\n  hidden:      Atom    yes|no (also works: y|n, true|false, t|f, 1|0)\n  notes:       Text    Internal notes"]])
          [:h3 "Prefixed values"]
          [:p
           "Prefixes are optional in all fields that take prefixed values,\nexcept "
           [:strong "ref:"]
           ", where prefixes are required because\nreferences can be of different kinds (thread, forum, post, hashtag).\n"]
          [:p "\nExamples:\n"]
          [:ul
           [:li [:kbd "nick:OP"] " or " [:kbd "nick:@OP"]]
           [:li [:kbd "thread:abcdef"] " or " [:kbd "thread:+abcdef"]]
           [:li [:kbd "forum:intel"] " or " [:kbd "forum:/intel"]]
           [:li [:kbd "tag:h1b"] " or " [:kbd "tag:#h1b"]]
           (when (= index "admin")
             [:<>
              [:li [:kbd "cookie:1Ab"] " or " [:kbd "cookie:*1Ab"]]
              [:li [:kbd "bfp:Bc2"] " or " [:kbd "bfp:~Bc2"]]])
           [:li
            [:em "BUT"]
            ": "
            [:kbd "ref:@OP+abcde"]
            " (prefix "
            [:code "@"]
            " required)\n\t\tor "
            [:kbd "ref:/intel"]
            " (prefix "
            [:code "/"]
            " required)"]]
          [:h3 "Boolean operators"]
          [:p
           "Boolean operators: "
           [:kbd "NOT"]
           ", "
           [:kbd "OR"]
           ", "
           [:kbd "AND"]
           " (must be capitalized!) can be applied in the text as well as inside field operators"]
          [:pre "NOT abcd uid:(lejla OR nerma)"]
          [:pre "word1 OR word2 cc:(NOT ba)"]
          [:pre "\"word1 AND word2\""]
          [:p "Boolean operators are only applied to one word that follows"]
          [:p "Shorthand:\n\t"]
          [:ul
           [:li [:kbd "NOT abcd"] " is equivalent to " [:kbd "-abcd"]]
           [:li [:kbd "cc:(NOT us)"] " is the same as " [:kbd "-cc:us"]]]
          [:p]
          [:h3 "Stem operator"]
          [:p
           "Stem operator: "
           [:kbd "~"]
           " (the tilde character) searches for common variations of a word, like plural forms and verb endings. This is a prefix operator which must precede a value with no intervening space. The value "
           [:kbd "~cat"]
           " will match \"cat\" or \"cats,\" and likewise "
           [:kbd "~dog"]
           " matches \"dog\" or \"dogs.\" The stemming algorithm is not fool-proof. The value "
           [:kbd "~care"]
           " will match \"care\" and \"caring,\" but not \"cares\" or \"cared.\""]
          [:h3 "Full documentation"]
          [:p
           [:a
            {:href
             "https://cloud.google.com/appengine/docs/standard/python/search/query_strings"}
            "Google's documentation"]]
          [:h3 "Examples"]
          [:ol
           [:li
            [:p
             "Search for word "
             [:strong "abcd"]
             " in all "
             [:strong "removed"]
             " posts from IP address "
             [:strong "1.2.3.4"]
             " created before or on "
             [:strong "November 18th, 2019 (UTC)"]]
            [:pre "abcd status:r ip:1.2.3.4 created <= 2019-11-18"]]
           [:li
            [:p
             "Search for all "
             [:strong "quarantined"]
             " posts from "
             [:strong "France"]
             " or "
             [:strong "Germany"]]
            [:p]
            [:pre "status:q cc:(fr OR de)"]]]])

       (when-not (empty? q)
         [:<>
          [:div.posts-head
           [:h1 "Results:"]
           [search-results-meta page limit query-params]
           [:div]]
          [:main#topics
           [:h2 "Posts"]
           [:section#posts
            [limit-btns @query-params]
            ;; [text-resizer]
            [posts-pager-n-layout query-params]]]])]]
     [common/message ::subs/message {:personal-moderator-logs true}]]))